import * as constAction from 'root/actionConstants';
import {Map, List, fromJS} from 'immutable';

var defaultState = Map({
  list: List(),
  logs: List(),
  usuarios: Map(),
  logsFiltered: List(),
  actionFilter: null
});

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case constAction.REGISTROS_CLEAR: {
      if(action.payload === 'all')
      return defaultState;
      else if(defaultState.has(action.payload))
      return state.set(action.payload, defaultState.get(action.payload));
      else {
        console.error('No existe la propiedad '+action.payload);
        return state;
      }
    }
    case constAction.REGISTROS_SET_STATE: {
      let newState = state;
      for (var key in action.payload) newState = newState.set(key, fromJS(action.payload[key]));
      return newState;
    }
    case constAction.REGISTROS_FILTER_BYACTION:{
      if(action.payload == null) return state.set('logsFiltered', Map());
      return state.set('logsFiltered', state.get('logs').filter( log => log.get('accion') == action.payload));
    }
    case constAction.REGISTROS_LOGS_CONCAT_STATE: {
      if(Array.isArray(action.payload)){
        if(action.payload.length > 0)
          return state.set('logs', fromJS(action.payload));
        return state.set('logs', state.get('logs').concat(fromJS(action.payload)));
      }
      else {
        return state.set('logs', state.get('logs').unshift(fromJS(action.payload.fullDocument)));
      }
    }
    case constAction.REGISTROS_SOCKET_DATA: {
      return state.set('list', state.get('list').unshift(fromJS(action.payload.fullDocument)));
    }
    case constAction.REGISTROS_USER_SET_STATE:{
      return state.setIn([ 'usuarios', action.payload.id], fromJS(action.payload));
    }
    default: return state;
  }
}



// WEBPACK FOOTER //
// src/modules/registros/reducer.js